import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import SelectTemplate from 'components/blocks/SelectTemplate';

const TemplateField = ({ setSelectedTemplate }) => {
  const { control, watch, setValue } = useFormContext();

  const isMultiMode = watch('isMultiMode');

  const onUpdateSelectedTemplate = field => template => {
    field.onChange(template?.id);
    setValue('selectedTemplateForceChoose', template?.forceChoose || null);
    if (template?.forceChoose) setValue('force_choose', template?.forceChoose);
    if (setSelectedTemplate) setSelectedTemplate(template || {});
  };

  return (
    <section className="send-mail-form__section">
      <h5>Email template *</h5>
      <Controller
        control={control}
        name="templateId"
        render={({ field, fieldState }) => {
          return (
            <SelectTemplate
              disabled={isMultiMode}
              error={fieldState.error?.message}
              name="templateId"
              selectedTemplateId={field.value}
              onBlur={field.onBlur}
              onUpdateSelectedTemplateData={onUpdateSelectedTemplate(field)}
            />
          );
        }}
      />
    </section>
  );
};

export default TemplateField;
